import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom';
import { StackedColumnChart } from 'bizcharts';
import { comma } from 'utils/function'
import { ApiExportExcel } from 'utils/api/export'
import html2canvas from "html2canvas";
import moment from 'moment';

import { Typography, Box, MenuItem, Select } from '@mui/material';
import {
    ApiFindDropdown

} from 'utils/api/analytics'
import DataSet from '@antv/data-set';
import {
    G2,
    Chart,
    Tooltip,
    Interval,
    Coord
} from "bizcharts";


import DialogSubmit from 'utils/components/modal-submit'

function ChartCustom({ title, data, color = null, filter = [], export_code = false, export_file = [] }) {
    const [fileExport, setFileExport] = useState(null)
    const [typeSubmit, setTypeSubmit] = useState('')
    const [openSubmit, setOpenSubmit] = useState(false)
    const [currentColor, setCurrentColor] = useState(color);
    const [currentData, setCurrentData] = useState(data);




    const handleOpenSubmit = (status, close) => {
        setOpenSubmit(status)
        if (close) {

            if (['EXCEL'].includes(fileExport)) {

                let status = handleExportExcel(export_code,filter, `excel-${title}`)
                if (status) {
                    // setFilterExport('null')
                    // setFilterDepartment('all')
                    // setFilterHospital('all')
                    // setFilterYear('all')

                }

            } else if (['PNG'].includes(fileExport)) {

                handleExportPNG()
    
                
            }

            setTypeSubmit()
            setFileExport(null)
        }
    }

    const chartRef = useRef(null);

    const handleExportExcel = async (excel_code, filter, file_name) => {

        let result = await ApiExportExcel({
            "export_code": excel_code,
            "file_name": file_name,
            "filter": filter
        })


        if (result?.status) {

            let { file_url } = result.data

            // Create a hidden anchor element for downloading the file
            const link = document.createElement('a');
            link.href = file_url;
            link.download = ''; // Optional: specify a custom filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return true

        } else {
            return false

        }





    }

    const handleExportPNG = () => {
        if (chartRef.current) {
            html2canvas(chartRef.current).then((canvas) => {
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                // link.download = "chart.png";
                link.download = `${title}-${moment(Date.now()).format('YYYY-MM-DD_HHmmss')}.png`

                link.click();
            });
        }

    };

    // useEffect(() => {

    //     ApiFindDropdown('file_export', { i_code: 'EXCEL' }).then(res => {
    //         if (res.status) {
    //             setFindFileExport(res.data)
    //         } else {
    //             setFindFileExport([])
    //         }
    //     })
    // }, [data])

    useEffect(() => {

        if (fileExport === 'EXCEL') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        } else if (fileExport === 'PNG') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        }

    }, [fileExport])

   


    const handleColor = (payload) => {
        // Return the dynamically updated `color` prop directly
        return currentColor?.[payload.type] || currentColor['default']; // Default color if group-specific color is not found
    };

    // Watch for changes in the `color` prop and update local state
    useEffect(() => {
        setCurrentColor(color);
    }, [color]);


    useEffect(()=>{

        const groupTotals = data && data.length > 0 ? data?.reduce((acc, item) => {
            acc[item.label] = (acc[item.label] || 0) + item.value;
            return acc;
        }, {}) : {}
    
        const data2 = data && data.length > 0 ? data?.map(item => ({
            ...item,
            percent: ((item.value / groupTotals[item.label]) * 100).toFixed(2), // Normalize to percentage
            value: item.value, // Normalize to percentage
    
        })) : []

        
        setCurrentData(data2)

    },[data])

    console.log("currentData : ",currentData);
    console.log("currentColor : ",currentColor);

    


    useEffect(() => {

        if (fileExport === 'EXCEL') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        } else if (fileExport === 'PNG') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        }

    }, [fileExport])


    return (

        <>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', flex: 1 }}>

                <Box sx={{ width: '50%' }}>
                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                        {title}
                    </Typography>
                </Box>

                <Box sx={{ width: '50%', position: 'relative' }}>
                    {export_file && export_file.length > 0 ? <>
                        <Select
                            size="small"
                            value={fileExport || "null"}
                            onChange={(e) => { setFileExport(e.target.value); }}
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: '#C8EBEB',
                                border: 'none',
                                zIndex: 10,
                                '.MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                            }}
                        >
                            <MenuItem value="null" disabled>
                                Export
                            </MenuItem>
                            {export_file.map((i, idx) => (
                                <MenuItem key={idx} value={i}>{i}</MenuItem>
                            ))}
                        </Select>
                    </> : null}
                </Box>

                <Box sx={{ width: '100%', pt: 3 }}>

                    <Box ref={chartRef}>
                        {color ? <StackedColumnChart
                            data={currentData}
                            autoFit
                            padding="auto"
                            xField="label"
                            yField="value"
                            // yField="percent"

                            stackField="type"
                            minColumnWidth={50}
                            maxColumnWidth={50}
                            color={handleColor} // Pass the dynamic color function
                            yAxis={{
                                // min: 0,
                                // max: 1, // Set the maximum value to 1 (100%)
                                label: {
                                    formatter: (v) => `${comma(v)}`, // Convert to percentage
                                    style: {
                                        fontSize: 12,
                                        fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                        fill: "#333",
                                        fontWeight: "bold",
                                    },
                                },
                            }}
                            xAxis={{
                                label: {
                                    style: {
                                        fontSize: 12,
                                        fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                        fill: "#333",
                                        fontWeight: "bold",
                                    },
                                },
                            }}
                            label={{
                                position: 'middle', // Positions the label inside the column
                                style: {
                                    fill: '#000', // White text for better contrast inside the column
                                    fontSize: 10,
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                    fontWeight: "bold",
                                },
                                formatter: (datum) => {
                                    
                                    let findPercent = currentData.find(d => d.type === datum.type && d.label === datum.label)

                                    return `${comma(datum.value)} (${findPercent.percent}%)`
                                }
                            }}
                            tooltip={{
                                showTitle: false,
                                formatter: (item) => {
                                    let findPercent = currentData.find(d => d.type === item.type && d.label === item.label)

                                    return ({

                                        name: item.type, // Directly access type
                                        value: `จำนวน ${comma(item.value)} คน (${findPercent.percent}%)`, // Directly access total
                                    })

                                }
                                ,
                                domStyles: {
                                    'g2-tooltip': {
                                        fontSize: '12px',
                                        fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                        color: "#333",
                                        fontWeight: "bold",
                                    },
                                },
                            }}
                            legend={{
                                position: "bottom",
                                itemName: {
                                    style: {
                                        fontSize: 12,
                                        fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                        fill: "#333",
                                        fontWeight: "bold",
                                    },
                                },
                            }}
                        /> : null}


                    </Box>
                    {/* <PieChart
						data={data}
						// title={{
						// 	visible: true,
						// 	text: title,
						// }}
						description={{
							visible: true,
							text: '',
						}}
						radius={0.7}
						angleField='total'
						colorField='label'
						tooltip={{
							showTitle: false, // Optional: Hide the title in the tooltip
							style: {
								fontSize: 12, // Set font size for the pie chart labels
								fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the pie chart labels
								fill: "#333", // Optional: Set font color for the labels
								fontWeight: 'bold'
							},
							// itemTpl: "<li>{label}: {total}</li>", // Customize the tooltip content
						}}
						color={["#CEC2EB",
							"#FFB6B9",
							"#8AC6D1",
							"#F9BCDD",
							"#FFF1AC",
							"#D5A4CF",
							"#FDC4B6",
							"#7F95D1",
							"#95E1D3",
							"#D4EDF4",
							"#E9BBA9",
							"#C08497",]}
						label={{
							visible: true,
							type: 'spider',
							// labelHeight: 28,
							// labelWidth:200,
							content: v => `${v.label}\n${comma(v.total)} (${v.y}%)`,
							style: {
								fontSize: 12, // Set font size for the pie chart labels
								fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the pie chart labels
								fill: "#333", // Optional: Set font color for the labels
								fontWeight: 'bold'
							},
						}}
						legend={{
							position: "bottom",
							itemName: {
								style: {
									fontSize: 12, // Set font size for the legend text
									fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the legend text
									fill: "#555", // Optional: Set font color for the legend text
									fontWeight: 'bold'
								},
							},
						}}
					/> */}



                </Box>

                <DialogSubmit

                    // loading={loading}
                    title={`${typeSubmit}`}
                    fileType={fileExport}
                    // type={alertType}
                    // message={messageAlert}
                    open={openSubmit}
                    setOpen={setOpenSubmit}
                    handleOpenSubmit={handleOpenSubmit}
                // handleChange={handleAlert}



                />
            </Box>






        </>

    );
}
export default ChartCustom;